import { COLORS } from '@btime/constants'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import { Label } from '../../../../packages/kiti/components/presentation/Text'
import Circle from '../../../../packages/kiti/components/shapes/Circle'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import NumberInput from '../../../../packages/kiti/components/form/NumberInput'
import Separator from '../../../../packages/kiti/components/helpers/Separator'

const GeneralSection = () => {
  const { t } = useTranslation('editSemaphore')

  return (
    <>
      <Grid paddingGutter={0.2} wrap>
        <Col width="50%">
          <Label noMargin>{t('warning')}</Label>
        </Col>

        <Col width="50%">
          <Label noMargin>{t('critic')}</Label>
        </Col>
      </Grid>
      <Grid paddingGutter={0.2} align="center">
        <Col>
          <Circle color={COLORS.yellow} key={'yellow'} borderWidth={0.2} />
        </Col>
        <FormItem path={['value', 'warning']} Input={NumberInput} />
        <Col>
          <Circle color={'red'} key={COLORS.red} borderWidth={0.2} />
        </Col>
        <FormItem path={['value', 'critic']} Input={NumberInput} />
      </Grid>
      <Separator weight={2} />
    </>
  )
}

export default GeneralSection
